export const sensorConstants = {
  SENSOR_ON: "ALL_SENSORS_ON",
  SENSOR_OFF: "ALL_SENSORS_OFF",
  SENSOR_LIST: "ALL_SENSORS_LIST",
  SENSOR_DATA: "ALL_SENSOR_DATA",
  SENSOR_ID: "SENSOR_ID",
  SENSOR_FILTER: "FILTERED_SENSOR_DATA"
};



// WEBPACK FOOTER //
// ./src/_constants/sensor.constants.js